import ApiService from "../../ApiService";
import AppConfig from "../../../config/AppConfig";

const ProfileSettingService = {
    loadScreenView: (successCallback, failureCallback) => {
        ApiService.post("/mobile/me/usersetting/load", {}, successCallback, failureCallback);
    },

    changeName: (firstName, lastName, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/usersetting/changename", { firstName: firstName, lastName: lastName }, successCallback, failureCallback);
    },

    changeGender: (gender, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/usersetting/changegender", { gender: gender }, successCallback, failureCallback);
    },

    changeBirthday: (newBirthday, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/usersetting/changebirthday", { birthDate: newBirthday }, successCallback, failureCallback);
    },

    changeMemberPhoto: (photo, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/usersetting/changephoto", { photoUrl: photo }, successCallback, failureCallback);
    },

    changeRole: (profile, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/usersetting/changerole", { profileType: profile }, successCallback, failureCallback);
    },

    setRecordConfig: (params, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/usersetting/setrecordconfig", params, successCallback, failureCallback);
    },
    getRecordConfig: (successCallback, failureCallback) => {
        ApiService.post("/mobile/me/usersetting/getrecordconfig", {}, successCallback, failureCallback);
    },

    postPhotoToServer: (file, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("fileData", file);
        formData.append("table", "User");
        formData.append("field", "Photo");
        formData.append("clientType", 1);
        formData.append("clientVersion", AppConfig.APP_CLIENT_VERSION);
        formData.append("clientBuild", AppConfig.APP_CLIENT_BUILD);

        ApiService.post("/common/file/upload", formData, successCallback, failureCallback);
    },

    linkWechat: (vo, successCallback, failureCallback) => {
        ApiService.post("/account/linkwechat", vo, successCallback, failureCallback);
    },

    unLinkWechat: (successCallback, failureCallback) => {
        ApiService.post("/account/unlinkwechat", {}, successCallback, failureCallback);
    },

    linkFacebook: (vo, successCallback, failureCallback) => {
        ApiService.post("/account/linkfacebook", vo, successCallback, failureCallback);
    },

    unLinkFacebook: (successCallback, failureCallback) => {
        ApiService.post("/account/unlinkfacebook", {}, successCallback, failureCallback);
    },

    linkGoogle: (vo, successCallback, failureCallback) => {
        ApiService.post("/account/linkgoogle", vo, successCallback, failureCallback);
    },

    unLinkGoogle: (successCallback, failureCallback) => {
        ApiService.post("/account/unlinkgoogle", {}, successCallback, failureCallback);
    },

    createMembershipFeeOrder: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/membership/createMembershipFeeOrder", vo, successCallback, failureCallback);
    },
};

export default ProfileSettingService;
